import {useContext} from "react";
import { UserContext } from "../Context/UserContext";
import "../styles/picks.css"

function OldPicks({currentDate}) {
    const {state} = useContext(UserContext);

    return (
        <div className="oldPicks">
            <br />
            {state.articles?.map(art => {
                const relAuthor = state?.authorsAndResults?.find(obj => obj?.author.id === art?.author_id)
                //console.log('relAuthor', relAuthor)
                const authorName = relAuthor?.author.first_name + ' ' + relAuthor?.author.last_name
                const artDate = new Date(art.created_at).toISOString().split("T")[0]
                // const artPicks = state.article_picks.filter
                const formattedArtDate = artDate.slice(5)
                //console.log('formattedArtDate', formattedArtDate)
                if (artDate < currentDate)
                return (
                    <div className="articles" key={art.id}>
                        <h2 className="title">{art.title}</h2>
                        <p className="bet">Bet: {art.bet}</p>
                        {art.body.split(/\n\s*\n/).map((para, i) => (
                            <p className="story" key={i}>{para.trim()}</p>
                        ))}
                        <p className="story">{art.conclusion}</p>
                        <p id="authorName">By: {authorName}</p>
                        <p>{artDate}</p>
                        {/* <p>Result: {}</p> */}
                    </div>
                )
                else return ''
            })}
        </div>
    )
}

export default OldPicks